import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import { HelmetProvider } from 'react-helmet-async'
import { ClerkProvider } from '@clerk/clerk-react'
import Clarity from '@microsoft/clarity'
import App from './App.jsx'

import ResearchDashboard from './pages/ResearchDashboard.jsx'
import ChangelogPage from './pages/ChangelogPage.jsx'
import AboutPage from './pages/AboutPage.jsx'
import FeedbackPage from './pages/FeedbackPage.jsx'
import DocsPage from './pages/DocsPage.jsx'
import NotFound from './components/NotFound.jsx'
import './index.css'

// Initialize Microsoft Clarity for behavioral analytics (heatmaps, session recordings)
// Project ID is public (visible in browser) so hardcoding is fine
Clarity.init('ulvmjiuvav')

const CLERK_PUBLISHABLE_KEY = 'pk_live_Y2xlcmsueGVsc2VkLmFpJA'

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <ClerkProvider
      publishableKey={CLERK_PUBLISHABLE_KEY}
      isSatellite
      domain="p5js.ai"
      signInUrl="https://xelsed.ai/sign-in"
    >
      <HelmetProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<App />} />
            <Route path="/editor" element={<App />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/docs" element={<DocsPage />} />
            <Route path="/feedback" element={<FeedbackPage />} />
            <Route path="/changelog" element={<ChangelogPage />} />
            <Route path="/research-insights-2025" element={<ResearchDashboard />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </BrowserRouter>
      </HelmetProvider>
    </ClerkProvider>
  </React.StrictMode>,
)
